<template>
<div>
    <router-view/>
</div>
</template>

<script>
export default {
  name: 'ControlDrugRegister',
  data () {
    return {
    }
  },
}
</script>

<style lang="scss">
</style>